class TokenService {
  getLocalRefreshToken() {
    const token = sessionStorage.getItem('loginToken');
    return token;
  }

  getLocalAccessToken() {
    const token = sessionStorage.getItem('loginToken');
    return token;
  }

  updateLocalAccessToken(token) {
    let localToken = sessionStorage.getItem('loginToken');
    localToken = token;
    sessionStorage.setItem('loginToken', localToken);
  }

  removeToken() {
    sessionStorage.removeItem('loginToken');
  }

  setToken(token) {
    sessionStorage.setItem('loginToken', token);
  }
}

export default new TokenService();
